import { Routes } from '@angular/router';
import { ScopeGuard } from '../auth/services/scope.guard';
import { SCOPES } from 'src/app/app.constants';
import { SALES_REGISTERS_ROUTES } from '../sales-registers/sales-registers.routes';
import { GIFT_CARD_ROUTES } from '../gift-cards/gift-card.routes';

import { SALES_RULES_ROUTES } from '../sales-rules/sales-rules.routes';

export const SALES_ROUTES: Routes = [
  { path: 'gift-cards', canActivate: [ScopeGuard], data: { scopes: [SCOPES.sales.view] }, children: GIFT_CARD_ROUTES },
  { path: 'registers', canActivate: [ScopeGuard], data: { scopes: [SCOPES.admin.sales.manage] }, children: SALES_REGISTERS_ROUTES },
  { path: 'rules', canActivate: [ScopeGuard], data: { scopes: [SCOPES.admin.sales.manage] }, children: SALES_RULES_ROUTES },
  {
    path: 'settings', loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.admin.sales.manage] }, children: [
      { path: 'payment-types', loadComponent: () => import('./components/settings/payment-types/payment-types.component').then(m => m.PaymentTypesComponent) },
      { path: 'registers/:id', loadComponent: () => import('./components/settings/register/register.component').then(m => m.RegisterComponent) },
      { path: 'registers', loadComponent: () => import('./components/settings/registers/registers.component').then(m => m.RegistersComponent) },
      { path: 'tools', loadComponent: () => import('./components/settings/tools/tools.component').then(m => m.ToolsComponent) },
      { path: '**', redirectTo: 'registers' }
    ]
  },
  { path: ':id', loadComponent: () => import('./components/sale-view/sale-view.component').then(m => m.SaleViewComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.sales.view] } },
  { path: '', loadComponent: () => import('./components/sale-list/sale-list.component').then(m => m.SaleListComponent), canActivate: [ScopeGuard], data: { scopes: [SCOPES.sales.view] } }
];
